import { jsx as _jsx } from "react/jsx-runtime";
import { withBaseIcon } from '../src/Icons.utils';
export const ChevronRightLine = (props) => withBaseIcon(_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", role: "img", children: _jsx("path", { d: "M10 6L16 12L10 18", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), props);
ChevronRightLine.iconName = 'chevron-right';
ChevronRightLine.displayName = 'ChevronRightLine';
export default ChevronRightLine;
